<header role="banner">
  <div class="content mt-5">
    <div class="content-margin">
      <div class="header-content">
        <div>
          <img src="../../../assets/images/WSIB_logo_RGB_4.svg" alt="Logo" class="printlogo">
        </div>
        <h1 class="mt-3"> {{"header.printtitle" | translate }}</h1>

        <p class="info mt-3">{{"header.printsubmissiondate" | translate }}: {{submitionDate}} {{"header.printsubmissiondateat" | translate }} {{submitionTime}}</p>
      </div>
    </div>
  </div>
</header>